import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgAndroidLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "-147 -70 294 345",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "#a4c639",
		children: [
			/* @__PURE__ */ _jsx("use", {
				strokeWidth: 14.4,
				xlinkHref: "#a",
				stroke: "#FFF"
			}),
			/* @__PURE__ */ _jsx("use", {
				xlinkHref: "#b",
				transform: "scale(-1 1)"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "b",
				stroke: "#FFF",
				strokeWidth: 7.2,
				children: [
					/* @__PURE__ */ _jsx("rect", {
						rx: 6.5,
						transform: "rotate(29)",
						height: 86,
						width: 13,
						y: -86,
						x: 14
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "c",
						rx: 24,
						height: 133,
						width: 48,
						y: 41,
						x: -143
					}),
					/* @__PURE__ */ _jsx("use", {
						y: 97,
						x: 85,
						xlinkHref: "#c"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "a",
				children: [/* @__PURE__ */ _jsx("ellipse", {
					cy: 41,
					rx: 91,
					ry: 84
				}), /* @__PURE__ */ _jsx("rect", {
					rx: 22,
					height: 182,
					width: 182,
					y: 20,
					x: -91
				})]
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		stroke: "#FFF",
		strokeWidth: 7.2,
		fill: "#FFF",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M-95 44.5H95" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: -42,
				r: 4
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 42,
				r: 4
			})
		]
	})]
});
export default SvgAndroidLogo;
